<template>
  <div class="discount-connection-approved">
    <div class="title">הבקשה לחיבור חשבון דיסקונט אושרה על ידי הבנק!</div>
    <div class="subtitle">בשביל לסיים את התהליך צריך להתחבר ולהזדהות באתר דיסקונט בעזרת מספר ת.ז</div>
    <text-input
      :autofocus="true"
      :labelText="'מספר ת.ז'"
      :value="idNumber"
      :onInput="setIdNumber"
      :error="!isValid"
      :topLeftLabel="errorMsg"/>
    <riseup-button :title="'המשך לאתר דיסקונט'" :variant="'discount'" :action="redirectBackToDiscount" :disabled="!isValid"/>
    <div class="separator"></div>
    <div class="logo-container">
      <img class="logo" :src="require('@/assets/bank-logos/discount.jpg')">
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import DiscountApi from '../../../../api/DiscountApi';
import Segment from '../../../../Segment';
import { isIsraeliIdValid } from '../../../../rules/validators';

export default {
  name: 'DiscountConnectionApprovedPage',
  components: {
    TextInput: BaseUI.TextInput,
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      idNumber: '',
      isValid: true,
      errorMsg: '',
    };
  },
  created() {
    Segment.trackUserGot('DiscountConnectionApprovedPageShown');
  },
  methods: {
    setIdNumber(value) {
      this.idNumber = value;
      this.isValid = true;
      this.errorMsg = '';
    },
    async redirectBackToDiscount() {
      this.isIdValid();
      if (this.isValid) {
        Segment.trackUserInteraction('DiscountConnectionApprovedPage_ContinueInDiscountClicked', { idNumber: this.idNumber });
        const requestId = this.$route.query.id;
        try {
          const response = await DiscountApi.getJointAccountRedirectUrl(this.idNumber, requestId);
          window.location.href = response.data.url;
        } catch (e) {
          this.isValid = false;
          if (e.response && e.response.status === 400 && e.response.data === 'No customer for id') {
            this.errorMsg = 'תעודת הזהות לא מופיעה במערכת';
          } else {
            throw e;
          }
        }
      } else {
        this.errorMsg = 'תעודת הזהות אינה תקינה';
      }
    },
    isIdValid() {
      this.isValid = isIsraeliIdValid(this.idNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .discount-connection-approved {
    margin: 30px;
    text-align: right;
    padding: 0 10px;

    .title {
      @include title;
      margin-top: 40px;
    }

    .subtitle {
      margin-top: 20px;
      margin-bottom: 40px;
      font-size: 16px;
      line-height: 26px;
    }

    .text-input, .riseup-button {
      width: 100%;
    }

    .separator {
      margin-top: 96px;
      height: 1px;
      width: 100%;
      background: $riseup_gray_0;
    }

    .logo-container {
      text-align: center;

      .logo {
        width: 90px;
        margin: 20px 0;
      }
    }
  }
</style>
